














































































import { defineComponent, PropType } from '@nuxtjs/composition-api';
import ProductDetailPopover from '~/components/pages/Product/Detail/ProductDetailPopover.vue';
import ProductWineBarGraph from '~/components/pages/Product/ProductWineBarGraph.vue';
import ProductWineColorLabel from '~/components/pages/Product/ProductWineColorLabel.vue';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppImage from '~/components/partials/App/AppImage.vue';
import AppPrice from '~/components/partials/App/AppPrice.vue';
import ProducingAreaFlag from '~/components/partials/ProducingArea/ProducingAreaFlag.vue';
import ProductLabel from '~/components/partials/Product/ProductLabel.vue';
import { filterReviewRating } from '~/utils/modules/products';
import { ProductDetailWineSetItem } from '~/types/modules/product';

export default defineComponent({
  components: {
    AppIcon,
    AppPrice,
    AppImage,
    ProductLabel,
    ProducingAreaFlag,
    ProductDetailPopover,
    ProductWineBarGraph,
    ProductWineColorLabel,
  },
  props: {
    data: {
      type: Object as PropType<ProductDetailWineSetItem>,
      required: true,
    },
    hasSize: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    return {
      filterReviewRating,
    };
  },
});
